import { render, staticRenderFns } from "./AlarmLevelTab.vue?vue&type=template&id=ca921ec0&scoped=true&"
import script from "./AlarmLevelTab.vue?vue&type=script&lang=js&"
export * from "./AlarmLevelTab.vue?vue&type=script&lang=js&"
import style0 from "./AlarmLevelTab.vue?vue&type=style&index=0&id=ca921ec0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca921ec0",
  null
  
)

export default component.exports